module.exports = __webpack_public_path__ + "img/1sb_five_stars_unselected_ekomi_d.dbc9ac9.svg";